// Alert plugin
// Imitates the native alert and confirm functions.
import jQuery from 'jquery';
import _ from 'lodash';
import i18next from 'i18next';

const $window = jQuery(window);
const $view_container = jQuery('#m2g-view[data-m2g-view]');
const $alert = jQuery('[data-view="alert"]');
const template = _.template($alert.find('[data-template]').html());
const default_options = {
    id: null,
    title: i18next.t('common:attention'),
    body: '',
    footer: true,
    primary_button: i18next.t('common:ok'),
    onPrimaryButtonClick: null,
    secondary_button: null, // e.g. 'Cancel'
    onSecondaryButtonClick: null,
    close_button: true,
    onClose: null,
    temp: false,
    temp_duration: 5600,
    show_progress_bar: false,
    el: null,
    placement: 'left',
    highlight_element: false,
};
let options = default_options;
let close_timeout;
let is_open = false;
const css_class = [
    'm2g-modal',
    'm2g-modal--small',
    'm2g-modal--alert',
    'm2g-modal--alert--closed',
].join(' ');
const { UI } = Mobi2Go;

$alert.delegate('[data-primary-button]', 'click', function() {
    close();
    if (_.isFunction(options.onPrimaryButtonClick)) {
        options.onPrimaryButtonClick();
    }
});

$alert.delegate('[data-secondary-button]', 'click', function() {
    close();
    if (_.isFunction(options.onSecondaryButtonClick)) {
        options.onSecondaryButtonClick();
    }
});

$alert.delegate('[data-close]', 'click', close);
Mobi2Go.UI.bind({
    modalOpen: close,
    closeAlert: close,
    pageLeave() {
        if (UI.page && !UI.page.isFrozen()) {
            close();
        }
    },
});

Mobi2Go.UI.alert = function(new_options) {
    // If an alert is already displaying, ensure that the onClose function
    // is fired.
    if (is_open && _.isFunction(options.onClose)) {
        options.onClose();
    }

    options = _.extend({}, default_options, new_options);
    reset();
    render();
    scheduleClose();
    updatePosition();
    highlightElement();

    open();
};

Mobi2Go.UI.closeAlert = function() {
    close();
    Mobi2Go.UI.closeCenteredAlert();
};
Mobi2Go.UI.updateAlertPosition = updatePosition;
Mobi2Go.UI.isAlertOpened = function isAlertOpened() {
    return is_open;
};

function render() {
    // Render template and refresh view
    const html = template(options);
    $alert.html(html);

    if (options.show_progress_bar) {
        startProgressBarAnimation();
    }

    $alert.attr('data-title', options.title);
    $alert.attr('data-id', options.id);
}

function scheduleClose() {
    // Set to close at a specified duration
    clearTimeout(close_timeout);
    if (options.temp && !Mobi2Go.app.disable_animation) {
        close_timeout = setTimeout(close, options.temp_duration);
    }
}

function reset() {
    $alert.attr({
        style: '',
        class: css_class,
    });
}

function open() {
    $alert[0].offsetWidth; // reflow
    $alert
        .addClass('m2g-modal--alert--open')
        .removeClass('m2g-modal--alert--closed');
    UI.trigger('alertOpen');
    bindUpdatePositionOnScroll();

    is_open = true;
}

function highlightElement() {
    if (options.highlight_element && options.el) {
        UI.helpers.highlightElement(jQuery(options.el));
    }
}

function close() {
    if (!is_open) {
        return;
    }
    is_open = false;

    $alert[0].offsetWidth; // reflow
    $alert
        .addClass('m2g-modal--alert--closed')
        .removeClass('m2g-modal--alert--open');

    unbindUpdatePositionOnScroll();

    const { onClose } = options;
    options.onClose = null; // Avoid infinite loop
    if (_.isFunction(onClose)) {
        onClose();
    }
}

function updatePosition() {
    options.el ? positionToElement() : positionCenter();
}

function positionCenter() {
    const window_height = $window.height();
    const view_height = $view_container.height();
    const view_offset = $view_container.offset().top;
    const modal_height = $alert.height();
    let offset = 0;
    const max_offset = view_height - modal_height;

    if (!Mobi2Go.app.isMobileUI()) {
        // Desktop UI scroll is relative to container
        // Mobile app view is full screen so it's fixed positioned with scroll consideration
        offset = $window.scrollTop() - view_offset;
    }

    if (window_height > modal_height) {
        offset += (window_height - modal_height) / 2;
    }

    if (offset < 0) offset = 0;
    if (offset > max_offset) offset = max_offset;

    setPosition({ top: offset });
}

function positionToElement() {
    if (!options.el) return;

    const $el = jQuery(options.el);
    const position = $el.position(); // Relative to .m2g-view element
    const el_width = $el[0].offsetWidth;
    const el_height = $el[0].offsetHeight;
    let alert_height;
    let alert_width;

    (alert_height = $alert[0].offsetHeight),
        (alert_width = $alert[0].offsetWidth);

    switch (options.placement) {
        case 'left':
            position.left -= alert_width;
            position.top -= alert_height / 2 - el_height / 2;
            break;
        case 'top':
            position.left -= (alert_width - el_width) / 2;
            position.top -= alert_height;
            break;
        case 'bottom':
            position.left -= (alert_width - el_width) / 2;
            position.top += el_height;
            break;
        default:
    }

    $alert.attr(
        'class',
        [
            'm2g-modal',
            'm2g-modal--small',
            'm2g-modal--alert',
            'm2g-modal--alert--open',
            ' m2g-modal--positioned',
            `m2g-modal--positioned--${options.placement}`,
        ].join(' ')
    );

    setPosition(position);
}

function startProgressBarAnimation() {
    _.defer(function() {
        $alert.find('[data-progress-bar]').css('width', '100%');
    });
}

function onScrollUpdatePosition() {
    window.requestAnimationFrame(updatePosition);
}

function bindUpdatePositionOnScroll() {
    $window.bind('scroll', onScrollUpdatePosition);
}

function unbindUpdatePositionOnScroll() {
    $window.unbind('scroll', onScrollUpdatePosition);
}

function setPosition(position) {
    $alert.css(position);
}
